import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { loadMoreList } from "@/mixins/index";
import prizeView from "./components/prizeView.vue";
export default {
  name: "userList",
  mixins: [loadMoreList],
  components: {
    prizeView: prizeView
  },
  data: function data() {
    return {
      pagingReqFn: "adminUserInfo",
      pagingReqValue: "data",
      drawer: false,
      delIds: []
    };
  },
  activated: function activated() {
    this.getList();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(e) {
      this.delIds = e;
    },
    viewOpen: function viewOpen(content) {
      this.content = this.$utils.textRepl(content);
      this.drawer = true;
    },
    del: function del(dateList) {
      var _this = this;

      var ids = dateList.map(function (item) {
        return item.id;
      });
      this.$store.dispatch('d2admin/method/deleteList', {
        req: 'serverStateDel',
        data: {
          id: ids.toString()
        }
      }).then(function () {
        _this.getList();
      });
    },
    exportdata: function exportdata() {
      var _this2 = this;

      this.$api.adminUserInfo({
        page: 1,
        page_size: 100000
      }).then(function (res) {
        if (res.code == 0) {
          res.data.data.map(function (i) {
            i.one_task = i.one_task == 0 ? "未完成" : "已完成";
            i.two_task = i.two_task == 0 ? "未完成" : "已完成";
            i.three_task = i.three_task == 0 ? "未完成" : "已完成";
            i.four_task = i.four_task == 0 ? "未完成" : "已完成";
            i.time = _this2.$times.convertDateTime(i.created_at);
          });
          var columns = [{
            label: '手机号',
            prop: 'phone'
          }, {
            label: '抽奖次数',
            prop: 'count'
          }, {
            label: '预约游戏',
            prop: 'one_task'
          }, {
            label: '关注公众号',
            prop: 'two_task'
          }, {
            label: '邀请预约',
            prop: 'three_task'
          }, {
            label: '分享页面',
            prop: 'four_task'
          }, {
            label: '注册时间',
            prop: 'time'
          }];

          _this2.$export.excel({
            columns: columns,
            data: res.data.data,
            title: '用户列表'
          });
        }
      });
    }
  }
};